module.exports = __webpack_public_path__ + "img/placeDefaultImg.b9d6a841.png";